import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-EditBtn',
  template: `
    <!-- <button mat-mini-fab color="primary" *ngIf="params.data.testStatus=='Pending' ? true: false" pTooltip="Edit" tooltipPosition="top" (click)="onClick($event)">
        <mat-icon>edit</mat-icon>
        </button> -->
    <button
      mat-mini-fab
      style="background-color: #1a8aa3;"
      *ngIf="params.data.executionStatus == 'Pending' ? true : false"
      mat-mini-fab
      pTooltip="Approve"
      tooltipPosition="top"
      (click)="onClick($event)"
      color="primary"
    >
      <mat-icon>check</mat-icon>
    </button>

    <!-- <button style="background-color: #16a34a;" mat-mini-fab ptooltip="View" tooltipPosition="top" (click)="onClick($event)"  color="primary"  ><mat-icon   >remove_red_eye</mat-icon> -->
    <button
      mat-mini-fab
      style="background-color: #16a34a;"
      mat-mini-fab
      pTooltip="View"
      tooltipPosition="top"
      (click)="onClick($event)"
      color="primary"
    >
      <mat-icon>remove_red_eye</mat-icon>
    </button>

    <button
      *ngIf="params.data.processTypeId == 3 ? false : true"
      mat-mini-fab
      style="background-color: #CC1100;"
      mat-mini-fab
      pTooltip="QR Code"
      tooltipPosition="top"
      (click)="onClick($event)"
      color="primary"
    >
      <mat-icon>qr_code_2</mat-icon>
    </button>
    <!-- <button
      mat-mini-fab
      style="background-color: #d9534f;"
      *ngIf="params.data.executionStatus == 'Pending' ? true : false"
      pTooltip="Delete"
      tooltipPosition="top"
      (click)="onClick($event)"
      color="warn"
    >
      <mat-icon>delete</mat-icon>
    </button> -->
  `,
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererEditBtn
  implements ICellRendererAngularComp, OnDestroy {
  public params: any;
  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }
  agInit(params: any): void {
    this.params = params;
  }
  onClick($event: any): any {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onClick(params);
    }
  }
  ngOnDestroy(): any {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
